import { render, staticRenderFns } from "./OrganizationCreateView.vue?vue&type=template&id=72ecde6e&"
import script from "./OrganizationCreateView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ecde6e')) {
      api.createRecord('72ecde6e', component.options)
    } else {
      api.reload('72ecde6e', component.options)
    }
    module.hot.accept("./OrganizationCreateView.vue?vue&type=template&id=72ecde6e&", function () {
      api.rerender('72ecde6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/OrganizationCreateView.vue"
export default component.exports